/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForPrivateCloud extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForPrivateCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForPrivateCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForPrivateCloud>): ServiceAccountNativeDetailsForPrivateCloud {
        let obj = Object.assign(new ServiceAccountNativeDetailsForPrivateCloud(), model);
        ServiceAccountNativeDetailsForPrivateCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForPrivateCloud>): ServiceAccountNativeDetailsForPrivateCloud {
        if (!model) return null;
        return ServiceAccountNativeDetailsForPrivateCloud.newInstance(<ServiceAccountNativeDetailsForPrivateCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForPrivateCloud) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForPrivateCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForPrivateCloud): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForPrivateCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Name. Used as the unique identifier for the private cloud environment. This is a required field.
     */
    organization_name: string;

}
